import { useState, useRef } from "react";

import { API_URL, getValFromLS, isFieldError } from "../helpers";

import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

export default function AllocationsForm({
	registrationId,
	total,
	golf,
	sporting,
	handleAllocationsUpdate,
}) {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		golf,
		sporting,
	});
	const [msg, setMsg] = useState({});

	let options = [];
	for (let i = 0; i <= total; i++) {
		options.push({ id: i, name: i });
	}

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/allocations`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("total", total);
		data.append("registrationId", registrationId);
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
				handleAllocationsUpdate(json.summaryGolf, json.summarySporting);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
			style={{ margin: "0", border: "none", borderRadius: "0" }}
		>
			<div className="form-group">
				<Select
					name="golf"
					label="Golf Allocation"
					reqd={true}
					value={names.golf || "0"}
					options={options}
					update={handleUpdate}
					error={isFieldError(errors, "golf")}
				/>

				<Select
					name="sporting"
					label="Sporting Clays Allocation"
					reqd={true}
					value={names.sporting || "0"}
					options={options}
					update={handleUpdate}
					error={isFieldError(errors, "sporting")}
				/>
			</div>

			<div className="msg-submit" style={{ marginTop: "30px" }}>
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" || msg.type === "notice"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit submit="Update Allocations" />
				</div>
			</div>
		</form>
	);
}
